import React, { useState, useEffect } from 'react'
import { useHistory, useLocation } from 'react-router-dom'

import loadingYapp from '../../assets/img/yapp_loading.gif'
import CardInteracion from '../../Components/CardInteraction/CardInteracion'
import { getProgramsByType, getS3File } from '../../Utils/api'
import { addEventNameWithParams, logEvent } from '../../Utils/utils'

function ProgramsDetail() {
  const history = useHistory()
  const location = useLocation()
  const [loading, setLoading] = useState(true)
  const [programs, setPrograms] = useState([])

  useEffect(() => {
    getProgramsByType(location.state?.type)
      .then((resp) => {
        setPrograms(resp.data)
        setLoading(false)
      })
      .catch(console.log)
  }, [])

  function goBack() {
    history.goBack()
  }

  const onClickOption = (item) => {
    logEvent('Material Checked', {
      'Material Type': 'Program',
      'Origin Material': 'Programs',
      'Material Id': item?.id,
      'Material Name': item?.name,
    })
    addEventNameWithParams('webapp-programs-patient-selected', {
      program_title: item?.name,
    })

    getS3File(item?.file, process.env.REACT_APP_BUCKETS_YAPP)
      .then((res) => {
        history.push('/pdf/viewer', { url: res?.data?.url })
      })
      .catch((err) => console.log(err))
  }

  return (
    <>
      <div className='py-3 px-3'>
        <div
          id={'gtm-medication-sheet-result'}
          className="content-responsive mx-auto d-flex justify-content-between ">
          <div className="breadcrumbs c-pointer" onClick={goBack}>
            <a className="d-flex align-items-center">
              <i className="icon-chevron-right icon-reverse"></i>
            </a>
            <span className="title-primary--regular line-14">Volver</span>
          </div>
        </div>
      </div>

      <div className="flex-grow-1 px-3">
        <div>
          <div className="content-responsive mx-auto">
            {loading ? (
              <img
                src={loadingYapp}
                alt="loading"
                className="loading-yapp--alternative mx-auto mt-5"
              />
            ) : (
              <div className="py-4">
                <h2 className="title-primary--xxl mb-2">
                  Programas de pacientes
                </h2>
                <p className="txt-paragraph line-16 mb-4">
                  Infórmate sobre programas de pacientes que ofrecen distintos
                  laboratorios.{' '}
                </p>
                <div className="content-card-product">
                  {programs?.map((item, key) => (
                    <CardInteracion
                      key={key}
                      id={`gtm-webapp-programs-result-${key}`}
                      doAction={() => onClickOption(item)}>
                      <div className="content-img-medication-sheet">
                        <img
                          src={item?.logo}
                          alt={`nombre del producto`}
                          className="img-mw-35"
                        />
                      </div>
                      <div className="ml-14 overflow-hidden">
                        <h2 className="title-primary--xl-bold mb-1 line-16 pr-2 text-ellipsis--2 ">
                          {item?.name}{' '}
                        </h2>
                      </div>
                    </CardInteracion>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  )
}

export default ProgramsDetail
